import { Button, CircularProgress, Typography } from '@material-ui/core';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import useCustomers from 'core/hooks/useCustomers';
import { CustomerFiltersSchema } from 'core/schemas/customerFilters';
import {
  Body,
  Column,
  GridTable,
  Header,
  Row as GridRow,
} from 'Elements/GridTable';
import LinkRow from 'Elements/GridTable/LinkRow';

const Row = styled(GridRow)`
  grid-template-columns: 80px minmax(150px, 1fr);
`;

const CenterColumn = styled(Column)`
  grid-column: 1 / 6;
  display: flex;
  justify-content: center;
`;

type Props = {
  params: CustomerFiltersSchema;
};

export default function CustomersTable({ params }: Props) {
  const { data: customers, loading, hasMore, loadMore } = useCustomers(params);

  return (
    <GridTable>
      <Header>
        <Row>
          <Column>AsNro</Column>
          <Column>Yritys</Column>
        </Row>
      </Header>

      <Body>
        {customers.map(customer => (
          <LinkRow to={'/customers/' + customer.id} key={customer.id}>
            <Row hover>
              <Column>{customer.number}</Column>
              <Column>{customer.company}</Column>
            </Row>
          </LinkRow>
        ))}
        <Row>
          <CenterColumn>
            {loading && <CircularProgress />}

            {!loading && hasMore && (
              <Button variant="contained" color="primary" onClick={loadMore}>
                Lataa lisää
              </Button>
            )}

            {!loading && !hasMore && (
              <Typography variant="subtitle1">
                Ei enempää asiakkaita,{' '}
                <Link to={`/customers/create`}>lisää uusi</Link>
              </Typography>
            )}
          </CenterColumn>
        </Row>
      </Body>
    </GridTable>
  );
}
